
import { useNavigate, useParams } from "react-router-dom"
import Layout from "../Frames/Layout"
import API from "../../services/API"
import Loader from "../Tools/Loader"
import { Alert, Stack, TextField, Typography } from "@mui/material"
import { useState } from "react"
import { useEffect } from "react"
import { useContext } from "react"
import UserContext from "../../services/Context/UserContext"
import ToastContext from "../../services/Context/ToastContext"
import { LoadingButton } from "@mui/lab"
import { Delete } from "@mui/icons-material"
import moment from "moment"
import Toggle from "../Inputs/Toggle"
import CoursePicture from "./Common/CoursePicture"
import Kind from "../Inputs/Kind"

export default function EventForm(){

    const {id} = useParams()

    const navigate = useNavigate()

    const {user} = useContext(UserContext)
    const {setToast} = useContext(ToastContext)

    const [data, setData] = useState({})

    const [status, setStatus] = useState('loading')

    const statusIs = str => str === status
    const statusIn = arr => arr.includes(status)

    useEffect(() => {

        if(id !== 'new'){

            API.get(`/design/courses/${id}`)
                .then(r => {
                    setData(r.data)
                    setStatus('ready')
                })
                .catch(e => {
                    console.error(e?.response?.data)
                    setStatus('error')
                })
            
        }else{

            setData({
                type: {id: 'event'},
                category: user.category,
                siret: user.siret,
                published: true,
                private: false,
                forum: false,
                startsOn: moment().add(1, 'month').format('YYYY-MM-DD'),
                startsAt: '09:00',
                endsOn: moment().add(1, 'month').format('YYYY-MM-DD'),
                endsAt: '18:00'
            })

            setStatus('ready')

        }

    }, [id, user])


    const handleSubmit = e => {
        e.preventDefault();

        setStatus('submit')

        save().then(r => handleSuccess(r))
            .catch(e => handleError(e))
            .finally(() => setStatus('ready'))
    }

    const save = async () => {

        if(id === 'new'){

            return await API.post(`/design/courses`, data);

        }else{

            return await API.put(`/design/courses/${id}`, data);
        }
    }

    const handleSuccess = r => {
        console.log(r.data)

        setToast({
            severity: 'success', 
            message: 'Vos modifications ont été enregistrées avec succès', 
            duration: 3000
        })

        if(id === 'new') navigate(`/organize/${r.data?.id}/overview`);
    }

    const handleError = e => {
        setToast({
            severity: 'error', 
            message: e.response?.data?.error || "Une erreur s'est produite. Vérifiez le formulaire.", 
            duration: 3000
        })
    }

    const handleDelete = () => {
        const ok = window.confirm("Êtes-vous sûr de vouloir supprimer cet événement ? Cette opération est irréversible.");

        if(!ok) return false;

        setStatus('delete');

        API.delete(`/design/courses/${data.id}`)
            .then(() => navigate('/courses'))
            .catch(() => {
                setStatus('ready');
                setToast({
                    severity: 'error', 
                    message: "L'événement n'a pas pu être supprimé", 
                    duration: 3000
                })
            })
    }


    const checkDates = () => moment(data.startsOn + 'T' + data.startsAt + ':00').valueOf() > moment().valueOf()
        && moment(data.startsOn + 'T' + data.startsAt + ':00').valueOf() 
            < moment(data.endsOn + 'T' + data.endsAt + ':00').valueOf()


    return <Layout menu='organize' tab='form' title=''>

        <form onSubmit={handleSubmit}>

            <Stack spacing={4} sx={{maxWidth: 600, margin: 'auto', pt: 4, pb: 4}}>

                <Typography variant='h1'>Informations générales</Typography>

                {statusIs('loading') && 
                    <Loader />
                }

                {statusIs('error') && 
                    <Alert severity='error'>Une erreur s'est produite.</Alert>
                }

                {statusIn(['ready','submit','delete']) && <>

                    <TextField
                        label="Nom de l'événement"
                        value={data.title || ''}
                        onChange={e => setData({...data, title: 
                            e.target.value
                        })}
                        required
                        size='small'
                        inputProps={{maxLength: 200}}
                        autoFocus
                    />

                    <Kind 
                        label="Type d'événement"
                        value={data.kind}
                        onChange={kind => setData({...data, kind})}
                        required
                    />

                    {!checkDates() && 
                        <Alert severity='warning'>
                            Les dates et horaires sont incorrects.
                        </Alert>
                    }

                    <Stack direction='row' spacing={2}>

                        <TextField
                            label="Date de début"
                            type="date"
                            value={data.startsOn}
                            onChange={e => setData({...data, startsOn: e.target.value})}
                            required
                            size='small'
                            sx={{flex: 1}}
                        />

                        <TextField
                            label="Heure de début"
                            type="time"
                            value={data.startsAt}
                            onChange={e => setData({...data, startsAt: e.target.value})}
                            required
                            size='small'
                            sx={{flex: 1}}
                        />

                    </Stack>

                    <Stack direction='row' spacing={2}>

                        <TextField
                            label="Date de fin"
                            type="date"
                            value={data.endsOn}
                            onChange={e => setData({...data, endsOn: e.target.value})}
                            required
                            size='small'
                            sx={{flex: 1}}
                        />

                        <TextField
                            label="Heure de fin"
                            type="time"
                            value={data.endsAt}
                            onChange={e => setData({...data, endsAt: e.target.value})}
                            required
                                size='small'
                                sx={{flex: 1}}
                            />

                    </Stack>

                    <TextField
                        label="Site web de l'événement"
                        type="url"
                        value={data.link || ''}
                        onChange={e => setData({...data, link: e.target.value})}
                        size='small'
                        inputProps={{maxLength: 250}}
                    />

                    <CoursePicture
                        id='course-picture'
                        value={data.picture}
                        onChange={file => setData({...data, picture: file})}
                    />

                    <Toggle
                        label="Publier l'événement"
                        value={data.published}
                        onChange={(e,v) => setData({...data, published: v})}
                    />

                    <LoadingButton
                        type='submit'
                        variant='contained'
                        loading={statusIs('submit')}
                    >
                        Enregistrer
                    </LoadingButton>

                    {id !== 'new' &&
                        <LoadingButton 
                            color='error'
                            startIcon={<Delete />} onClick={handleDelete}
                            loading={statusIs('delete')}
                            variant='outlined'
                            type='button'
                        >
                            Supprimer l'événement
                        </LoadingButton>
                    }

                </>}

            </Stack>

        </form>

    </Layout>
}
